import React,  { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsReact from 'highcharts-react-official'
import {gauge} from './ChartType'


export default class ChartTypeGouge extends Component {
  constructor(props){
    super(props)
    this.state = {
      options: gauge,
    }
  }

  render(){
    return(<HighchartsReact          
      highcharts={HighchartsMore(Highcharts)}
      options={this.state.options}
    />)
  }

}